import classnames from 'classnames';
import { SelectCasesType } from '@lp/features/MultiSuggest/types';
import { Case } from '@/api/apis/case';
import { SelectedCaseChip } from './SelectedCaseChip';

type SelectedCasesInfoProps = {
  type: SelectCasesType;
  initialCase: Case | null;
  targetCases: Case[];
  onRemoveCase: (caseItem: Case) => void;
};

export const SelectedCasesInfo = ({ type, initialCase, targetCases, onRemoveCase }: SelectedCasesInfoProps) => {
  const isInitialType = type === SelectCasesType.Initial;

  return (
    <div className="flex items-center">
      <div
        className="bg-base-60 text-base-20 relative h-9 z-20 flex rounded-l-xl items-center gap-3 pl-3 pr-6"
        style={{
          clipPath: 'polygon(0 0, calc(100% - 8px) 0, 100% 50%, calc(100% - 8px) 100%, 0 100%)',
        }}
      >
        <span className={classnames('text-l-sb', isInitialType ? 'text-base-5' : 'text-base-20')}>Initial Case</span>
        {initialCase ? (
          <SelectedCaseChip
            data={initialCase}
            isDisable={!isInitialType}
            isCloseable={isInitialType}
            onRemove={onRemoveCase}
          />
        ) : (
          <span className="text-m-r text-base-25">Not selected</span>
        )}
      </div>
      <div
        className="bg-base-60 text-base-5 relative z-10 -ml-1 flex h-9 rounded-r-xl items-center gap-3 pl-6 pr-3"
        style={{
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%, 8px 50%)',
        }}
      >
        <span className={classnames('text-l-sb', isInitialType ? 'text-base-20' : 'text-base-5')}>
          {`Target Cases (${targetCases.length} of 3)`}
        </span>
        {targetCases.length ? (
          <div className="flex gap-2 items-center">
            {targetCases.map((item) => (
              <SelectedCaseChip
                key={`target-case-${item.caseId}`}
                data={item}
                isDisable={isInitialType}
                isCloseable={!isInitialType}
                onRemove={onRemoveCase}
              />
            ))}
          </div>
        ) : (
          <span className="text-m-r text-base-25">Not selected</span>
        )}
      </div>
    </div>
  );
};
